module.exports = __webpack_public_path__ + "static/media/trackandfield_icon-01.8e02deb6.png";